import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const guideLinks = [
  { label: 'How to Use Pandabuy Sheet', to: '/article/pandabuy-spreadsheet-guide' },
  { label: 'Beginner\'s Guide', to: '/article/pandabuy-spreadsheet-for-beginners' },
  { label: 'Best Finds 2026', to: '/article/best-pandabuy-spreadsheet-finds-2026' },
  { label: 'Sneakers Spreadsheet', to: '/article/pandabuy-sneakers-spreadsheet' },
  { label: 'Clothing Spreadsheet', to: '/article/pandabuy-clothing-spreadsheet' },
  { label: 'Shipping Guide', to: '/article/pandabuy-spreadsheet-shipping-guide' },
  { label: 'Trusted Sellers', to: '/article/pandabuy-trusted-sellers-guide' },
  { label: 'Budget Finds', to: '/article/pandabuy-budget-finds' },
  { label: 'QC Photo Guide', to: '/article/pandabuy-spreadsheet-qc-guide' },
  { label: 'Safety Tips', to: '/article/pandabuy-spreadsheet-safety-tips' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="py-14 md:py-16">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              <div className="lg:w-1/4">
                <Link to="/" className="text-xl font-heading font-bold tracking-tight text-foreground-950">
                  Pandabuy<span className="font-light">.autos</span>
                </Link>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-xs">
                  Your trusted source for the best Pandabuy Spreadsheet. Updated daily with verified sellers, fresh finds, and complete buying guides to help you shop smarter.
                </p>
                <Link
                  to="/article/pandabuy-spreadsheet-for-beginners"
                  className="inline-flex items-center gap-1.5 mt-5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  New to Pandabuy? Start Here
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </Link>
              </div>

              <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
                <div>
                  <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-4">Categories</h4>
                  <ul className="flex flex-col gap-2.5">
                    {categories.map((cat) => (
                      <li key={cat.name}>
                        <a
                          href={cat.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                        >
                          {cat.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="col-span-2 sm:col-span-1">
                  <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-4">Guides & Articles</h4>
                  <ul className="grid grid-cols-2 sm:grid-cols-1 gap-2.5">
                    {guideLinks.map((link) => (
                      <li key={link.to}>
                        <Link to={link.to} className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <div>
                  <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-4">Quick Links</h4>
                  <ul className="flex flex-col gap-2.5">
                    <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">Browse Full Spreadsheet</a></li>
                    <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">Privacy Policy</a></li>
                    <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">Terms of Service</a></li>
                    <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">Disclaimer</a></li>
                    <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer">Contact</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="py-5 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 Pandabuy.autos. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/article/pandabuy-spreadsheet-safety-tips" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">Safety</Link>
              <span className="text-foreground-300">|</span>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">Privacy</a>
              <span className="text-foreground-300">|</span>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">Terms</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}